define("media/errors/index", ["exports", "media/errors/credentials", "media/errors/fetch", "media/errors/media-library"], function (_exports, _credentials, _fetch, _mediaLibrary) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "CredentialsMissingPermissionsError", {
    enumerable: true,
    get: function () {
      return _credentials.CredentialsMissingPermissionsError;
    }
  });
  Object.defineProperty(_exports, "CredentialsNotFoundError", {
    enumerable: true,
    get: function () {
      return _credentials.CredentialsNotFoundError;
    }
  });
  Object.defineProperty(_exports, "FetchError", {
    enumerable: true,
    get: function () {
      return _fetch.FetchError;
    }
  });
  Object.defineProperty(_exports, "ImageSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.ImageSizeError;
    }
  });
  Object.defineProperty(_exports, "MediaSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.MediaSizeError;
    }
  });
  Object.defineProperty(_exports, "MediaUploadError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.MediaUploadError;
    }
  });
  Object.defineProperty(_exports, "NetworkError", {
    enumerable: true,
    get: function () {
      return _fetch.NetworkError;
    }
  });
  Object.defineProperty(_exports, "RequestError", {
    enumerable: true,
    get: function () {
      return _fetch.RequestError;
    }
  });
  Object.defineProperty(_exports, "ServerError", {
    enumerable: true,
    get: function () {
      return _fetch.ServerError;
    }
  });
  Object.defineProperty(_exports, "UpgradeMediaSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.UpgradeMediaSizeError;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"media/errors/credentials",0,"media/errors/fetch",0,"media/errors/media-library"eaimeta@70e063a35619d71f
});